<div [ngClass]="containerClass" class="layout-container">

  <app-topbar></app-topbar>
  <!--    <app-rightmenu></app-rightmenu>-->
  <app-sidebar *ngIf="!router.url.includes('manage-portals')"></app-sidebar>

  <div [ngClass]="router.url.includes('manage-portals') ? 'layout-manage-portals' : 'layout-content-wrapper'">
    <!--        <app-breadcrumb></app-breadcrumb>-->
    <dynamic-breadcrumb *ngIf="!router.url.includes('manage-portals')"></dynamic-breadcrumb>
    <div [ngClass]="isInternalView ? 'layout-content-docs' : 'layout-content' ">
      <router-outlet></router-outlet>
    </div>

    <!--        <app-footer></app-footer>-->
  </div>
  <!--    <app-config></app-config>-->

  <div *ngIf="layoutService.state.staticMenuMobileActive" class="layout-mask"></div>
</div>
